module.exports = {"350303001":"涵东街道","350303002":"涵西街道","350303100":"三江口镇","350303101":"白塘镇","350303102":"国欢镇","350303103":"梧塘镇","350303104":"江口镇","350303105":"萩芦镇","350303106":"白沙镇","350303107":"庄边镇","350303108":"新县镇","350303200":"大洋乡","350303500":"赤港开发区"}


//////////////////
// WEBPACK FOOTER
// ./src/town/350303.json
// module id = 1085
// module chunks = 0